import * as THREE from "three";
import {TransformControls} from "three/examples/jsm/controls/TransformControls";
import {OrbitControls} from "../Libs/Orbitcontrols";
import {DragControls} from "three/examples/jsm/controls/DragControls";
import {ViewHelper} from "../Libs/ViewHelper";

class World {
  constructor(graphics, name) {
    this.graphics = graphics;
    if (name === "default") {
      this.defaultWorld(name);
    }
  }

  defaultWorld = name => {
    let scene = new THREE.Scene();
    scene.name = name;
    scene.key = scene.uuid;
    scene.title = name;
    scene.userData.script = "";
    scene.userData.scriptJS = `function Setup() {\n\n}\n\nfunction OnJoinPlayer() {\n\n}`;
    scene.userData.postProcessing = {};
    scene.userData.toneMapping = {};

    let skyPath = "asset/sky/bluesky/bluesky";
    let sky = {
      SKY: [skyPath + "_px.png", skyPath + "_nx.png", skyPath + "_py.png", skyPath + "_ny.png", skyPath + "_pz.png", skyPath + "_nz.png"],
    };
    scene.background = this.graphics.cubeTextureLoader.load(sky.SKY, () => {
      scene.background.name = "blue sky";
      scene.background.key = scene.background.uuid;
      scene.background.title = "blue sky";
      scene.background.userData = {type: "sky"};
      scene.background.encoding = THREE.sRGBEncoding;
      scene.background.needsUpdate = true;
      this.graphics.render();
    });

    let sceneHelpers = new THREE.Scene();

    this.graphics.sceneEdit = scene;
    this.graphics.sceneHelpers = sceneHelpers;

    // orthographicCamera for GUI
    let sceneGUI = new THREE.Scene();
    sceneGUI.name = "GUI";
    sceneGUI.key = sceneGUI.uuid;
    sceneGUI.title = "GUI";
    let guiCamera = new THREE.OrthographicCamera(
      window.innerWidth / -2,
      window.innerWidth / 2,
      window.innerHeight / 2,
      window.innerHeight / -2,
      1,
      1000,
    );
    guiCamera.position.set(0, 0, 500);
    guiCamera.layers.enableAll();
    guiCamera.layers.disable(4);

    this.graphics.sceneGUI = sceneGUI;
    this.graphics.guiCamera = guiCamera;

    // grid
    var grid = new THREE.Group();

    var grid1 = new THREE.GridHelper(30, 30, 0x888888);
    grid1.material.color.setHex(0x888888);
    grid1.material.vertexColors = false;
    grid.add(grid1);

    var grid2 = new THREE.GridHelper(30, 6, 0x222222);
    grid2.material.color.setHex(0x222222);
    grid2.material.depthFunc = THREE.AlwaysDepth;
    grid2.material.vertexColors = false;
    grid.add(grid2);

    this.graphics.grid = grid;

    let camera = new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 1, 1000);
    camera.position.set(0, 7, 20);
    camera.lookAt(0, 0, 0);
    camera.layers.enableAll();
    camera.layers.disable(4);
    this.graphics.editCamera = camera;

    // Light
    let directLight = new THREE.DirectionalLight(0xffffff, 1);
    directLight.position.set(5, 10, 7.5);
    directLight.castShadow = true;
    directLight.name = "DirectionalLight";
    this.graphics.postAddObject(directLight);

    let ambiLight = new THREE.AmbientLight({color: 0x222222});
    ambiLight.intensity = 0.6;
    ambiLight.name = "AmbientLight";
    this.graphics.postAddObject(ambiLight);

    // Controls
    let orbit = new OrbitControls(camera, this.graphics.labelRenderer.domElement, this.graphics);
    orbit.listenToKeyEvents(window);
    orbit.addEventListener("change", () => {
      this.graphics.render();
    });
    orbit.update();
    this.graphics.orbit = orbit;

    let transform = new TransformControls(camera, this.graphics.labelRenderer.domElement);
    this.graphics.transform = transform;
    this.graphics.transform.addEventListener("change", () => {
      let object = this.graphics.transform.object;
      if (object !== undefined) {
        this.graphics.selectionBox.setFromObject(object);
        this.graphics.updateAudioHelper(object);
        let helper = this.graphics.helpers[object.id];
        if (helper !== undefined && helper.isSkeletonHelper !== true) {
          helper.update();
        }
      }
      this.graphics.render();
    });
    this.graphics.sceneHelpers.add(transform);

    let dragControl = new DragControls([...sceneGUI.children], guiCamera, this.graphics.labelRenderer.domElement);

    this.graphics.dragControl = dragControl;

    // ViewHelper (Gizmo)
    let viewHelper = new ViewHelper(this.graphics.editCamera, this.graphics.labelRenderer.domElement);
    viewHelper.center = orbit.target;
    this.graphics.viewHelper = viewHelper;
    this.activateGizmo();

    const tileTexture = "asset/ground/studio_tile_plate_g.png";
    //GROUND
    new THREE.TextureLoader().load(tileTexture, texture => {
      const gg = new THREE.BoxGeometry(128, 128, 1);
      const gm = new THREE.MeshStandardMaterial({
        map: texture,
        flatShading: true,
      });
      const ground = new THREE.Mesh(gg, gm);
      ground.rotation.x = -Math.PI / 2;
      ground.material.map.repeat.set(64, 64);
      ground.material.map.wrapS = THREE.RepeatWrapping;
      ground.material.map.wrapT = THREE.RepeatWrapping;
      ground.material.map.encoding = THREE.sRGBEncoding;
      ground.material.map.needsUpdate = true;
      ground.receiveShadow = true;
      // ground.castShadow = true;
      ground.position.set(0, -0.5, 0);
      ground.layers.set(1);
      ground.userData = {
        type: "ground",
        friction: 10,
        canCollide: true,
        isSprite: true,
      };
      scene.add(ground);
      ground.key = ground.uuid;
      ground.title = `ground(${ground.id})`;
      ground.name = "ground";

      this.graphics.ground = ground;
      this.graphics.render();
    });

    return {
      name: name,
      sceneEdit: scene,
      sceneHelpers: sceneHelpers,
      transform: transform,
      orbit: orbit,
    };
  };

  activateGizmo() {
    if (document.querySelector("#viewHelper")) return;
    const viewHelperArea = document.createElement("div");
    viewHelperArea.id = "viewHelper";
    viewHelperArea.style.position = "absolute";
    viewHelperArea.style.right = "0px";
    viewHelperArea.style.bottom = "0px";
    viewHelperArea.style.height = `${this.graphics.viewHelper.dim}px`;
    viewHelperArea.style.width = `${this.graphics.viewHelper.dim}px`;
    viewHelperArea.addEventListener("pointerup", event => {
      event.stopPropagation();
      this.graphics.viewHelper.handleClick(event);
      this.graphics.render();
    });
    viewHelperArea.addEventListener("pointerdown", event => {
      event.stopPropagation();
    });
    this.graphics.labelRenderer.domElement.appendChild(viewHelperArea);
  }

  deactivateGizmo() {
    const viewHelperArea = document.querySelector("#viewHelper");
    if (viewHelperArea) {
      viewHelperArea.remove();
    }
  }

  shiftGizmo(shifted) {
    const viewHelperArea = document.querySelector("#viewHelper");
    if (viewHelperArea) {
      viewHelperArea.style.right = `${shifted ? 240 : 0}px`;
    }
    this.graphics.viewHelper.shiftedOffset = shifted ? 240 : 0;
    this.graphics.render();
  }
}
export default World;
